import { createSlice } from '@reduxjs/toolkit';
import { filterEditedDays, filterWeekSummary } from '../utils/autobooking';

const initialState = {
  weekSummary: null,
  intervals: null,
  editedDays: [],
  tennisWeekSummary: null,
  tennisIntervals: null,
  tennisEditedDays: [],
  addIntervalError: null,
  addTennisIntervalError: null,
  isModified: false,
  tempLink: '',
};

const autobookingSlice = createSlice({
  name: 'autobooking',
  initialState,
  reducers: {
    aGetAutobookingSuccess: (state, action) => {
      state.weekSummary = action.payload.weekSummary;
      state.intervals = action.payload.intervals;
      state.initialWeekSummary = { ...action.payload.weekSummary };
      state.initialIntervals = [...action.payload.intervals];
      state.editedDays = [];
    },
    aGetTennisAutobookingSuccess: (state, action) => {
      state.tennisWeekSummary = action.payload.weekSummary;
      state.tennisIntervals = action.payload.intervals;
      state.tennisInitialWeekSummary = { ...action.payload.weekSummary };
      state.tennisInitialIntervals = [...action.payload.intervals];
      state.tennisEditedDays = [];
    },
    aChangeIntervalsSuccess: (state, action) => {
      state.weekSummary = action.payload.weekSummary;
      state.intervals = action.payload.intervals;
      state.editedDays = action.payload.editedDays;
      state.isModified = true;
      state.addIntervalError = null;
    },
    aChangeTennisIntervalsSuccess: (state, action) => {
      state.tennisWeekSummary = action.payload.weekSummary;
      state.tennisIntervals = action.payload.intervals;
      state.tennisEditedDays = action.payload.editedDays;
      state.isModified = true;
      state.addTennisIntervalError = null;
    },
    aAddIntervalError: (state, action) => {
      state.addIntervalError = action.payload.errorMessage;
    },
    aDeleteInterval: (state, action) => {
      let weekSummary = state.weekSummary;
      let intervals = state.intervals;
      let editedDays = state.editedDays;
      const initialIntervals = state.initialIntervals;
      editedDays = filterEditedDays(intervals,
        initialIntervals, action.payload.intervalId, editedDays);
      intervals = intervals.filter((x) => x.intervalId !== action.payload.intervalId);
      weekSummary = filterWeekSummary(weekSummary, action.payload.intervalId);

      state.weekSummary = weekSummary;
      state.intervals = intervals;
      state.editedDays = editedDays;
      state.isModified = true;
    },
    aDeleteTennisInterval: (state, action) => {
      let weekSummary = state.tennisWeekSummary;
      let intervals = state.tennisIntervals;
      let editedDays = state.tennisEditedDays;
      const initialIntervals = state.tennisInitialIntervals;
      editedDays = filterEditedDays(intervals,
        initialIntervals, action.payload.intervalId, editedDays);
      intervals = intervals.filter((x) => x.intervalId !== action.payload.intervalId);
      weekSummary = filterWeekSummary(weekSummary, action.payload.intervalId);

      state.tennisWeekSummary = weekSummary;
      state.tennisIntervals = intervals;
      state.tennisEditedDays = editedDays;
      state.isModified = true;
    },
    aClearChanges: (state) => {
      state.weekSummary = state.initialWeekSummary;
      state.intervals = state.initialIntervals;
      state.isModified = false;
      state.editedDays = null;
    },
    aClearTennisChanges: (state) => {
      state.tennisWeekSummary = state.tennisInitialWeekSummary;
      state.tennisIntervals = state.tennisInitialIntervals;
      state.isModified = false;
      state.tennisEditedDays = [];
    },
    aSaveChangesSuccess: (state) => {
      state.initialWeekSummary = state.weekSummary;
      state.initialIntervals = state.intervals;
      state.isModified = false;
      state.editedDays = null;
    },
    aSaveTennisChangesSuccess: (state) => {
      state.tennisInitialWeekSummary = state.tennisWeekSummary;
      state.tennisInitialIntervals = state.tennisIntervals;
      state.isModified = false;
      state.tennisEditedDays = [];
    },
    aClearIntervalErrors: (state) => {
      state.addIntervalError = null;
    },
    aSetTempLink: (state, action) => {
      state.tempLink = action.payload.tempLink;
    },
    aClearTempLink: (state) => {
      state.tempLink = '';
      state.isModified = false;
    },
  },
});

export const {
  aGetAutobookingSuccess,
  aGetTennisAutobookingSuccess,
  aChangeIntervalsSuccess,
  aChangeTennisIntervalsSuccess,
  aAddIntervalError,
  aDeleteInterval,
  aDeleteTennisInterval,
  aClearChanges,
  aClearTennisChanges,
  aSaveChangesSuccess,
  aSaveTennisChangesSuccess,
  aClearIntervalErrors,
  aSetTempLink,
  aClearTempLink,
} = autobookingSlice.actions;

export default autobookingSlice.reducer;
